(() => {
  document.querySelectorAll('[data-ef-fireplace-proof]').forEach(section => {
    if (section.dataset.reviewBound) return;
    section.dataset.reviewBound = 'true';
    const mount = section.querySelector('#looxReviews');
    const fallback = section.querySelector('[data-ef-fireplace-review-fallback]');
    if (!mount || !fallback) return;
    let framePending = false;
    function measure() {
      framePending = false;
      const iframe = mount.querySelector('iframe');
      if (!iframe || iframe.getBoundingClientRect().height < 180) return;
      fallback.hidden = true;
    }
    function queueMeasure() {
      if (framePending) return;
      framePending = true;
      requestAnimationFrame(measure);
    }
    const observer = new MutationObserver(queueMeasure);
    observer.observe(mount, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'height'] });
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(queueMeasure).observe(mount);
    window.addEventListener('resize', queueMeasure, { passive: true });
    mount.addEventListener('load', queueMeasure, true);
    // Loox alone decides whether more reviews exist and owns pagination.
    setTimeout(() => { const iframe = mount.querySelector('iframe'); if (!iframe || iframe.getBoundingClientRect().height < 180) fallback.hidden = false; }, 12000);
    queueMeasure();
  });
  document.querySelectorAll('.ef-fireplace-related').forEach(section => {
    const rail = section.querySelector('[data-ef-fireplace-rail]');
    const controls = section.querySelector('[data-ef-fireplace-rail-controls]');
    if (!rail || !controls || rail.dataset.bound) return;
    rail.dataset.bound = 'true';
    const previous = controls.querySelector('[data-ef-fireplace-previous]');
    const next = controls.querySelector('[data-ef-fireplace-next]');
    function update() {
      controls.hidden = rail.scrollWidth <= rail.clientWidth + 2;
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    }
    function move(direction) {
      const card = rail.firstElementChild;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      rail.scrollBy({left: direction * ((card?.getBoundingClientRect().width || rail.clientWidth) + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(update).observe(rail);
    update();
  });
})();
